/**
 * Desktop product gallery — swap hero media with clicked additional thumbnail in place.
 * Swaps inner media containers only so hero/thumbnail layout slots stay correct.
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function getHeroItem(wrapper) {
    var mainList = wrapper.querySelector('.product__media-list:not(.product__media-list--additional)');
    if (!mainList) return null;
    return mainList.querySelector('.product__media-item:first-child');
  }

  function swapNodes(nodeA, nodeB) {
    var parentA = nodeA.parentNode;
    var parentB = nodeB.parentNode;
    var markerA = document.createComment('swap-a');
    var markerB = document.createComment('swap-b');

    parentA.insertBefore(markerA, nodeA);
    parentB.insertBefore(markerB, nodeB);

    parentB.insertBefore(nodeA, markerB);
    parentA.insertBefore(nodeB, markerA);

    markerA.remove();
    markerB.remove();
  }

  function resetHeroMedia(heroItem) {
    var container = heroItem.querySelector('.product-media-container');
    if (container) {
      container.style.width = '';
      container.style.height = '';
      container.style.maxWidth = '';
      container.style.maxHeight = '';
      container.style.minHeight = '';
    }

    heroItem.querySelectorAll('.media img').forEach(function (img) {
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.width = '';
      img.style.height = '';
      img.style.maxWidth = '';
      img.style.maxHeight = '';
    });
  }

  function resetThumbMedia(thumbItem) {
    thumbItem.querySelectorAll('.media img').forEach(function (img) {
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.width = '';
      img.style.height = '';
      img.style.maxWidth = '';
      img.style.maxHeight = '';
    });
  }

  function swapMediaContent(heroItem, thumbItem) {
    var heroContainer = heroItem.querySelector('.product-media-container');
    var thumbContainer = thumbItem.querySelector('.product-media-container');
    if (!heroContainer || !thumbContainer) return;

    var wrapper = heroItem.closest('.product__media-wrapper');

    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }

    function performSwap() {
      swapNodes(heroContainer, thumbContainer);

      var heroMediaId = heroItem.dataset.mediaId;
      heroItem.dataset.mediaId = thumbItem.dataset.mediaId;
      thumbItem.dataset.mediaId = heroMediaId;

      resetHeroMedia(heroItem);
      resetThumbMedia(thumbItem);

      if (wrapper) wrapper.classList.remove('is-media-swapping');
    }

    if (!wrapper) {
      performSwap();
      return;
    }

    wrapper.classList.add('is-media-swapping');
    window.setTimeout(performSwap, 180);
  }

  function onAdditionalClick(event) {
    if (!DESKTOP_MQ.matches) return;

    var thumbItem = event.target.closest('.product__media-item--additional');
    if (!thumbItem) return;

    var wrapper = thumbItem.closest('.product__media-wrapper');
    if (!wrapper) return;

    var heroItem = getHeroItem(wrapper);
    if (!heroItem || heroItem === thumbItem) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    swapMediaContent(heroItem, thumbItem);
  }

  function bindAdditionalList(list) {
    if (!list || list.dataset.mediaSwapBound === 'true') return;
    list.dataset.mediaSwapBound = 'true';
    list.addEventListener('click', onAdditionalClick, true);
  }

  function init(root) {
    if (!document.body.classList.contains('product-page')) return;

    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('.product__media-list--additional').forEach(bindAdditionalList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
